import { Trans, useTranslate } from "@similarweb/i18n-provider";
import { Info24px } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";

import { ALERTS_TOAST_BUTTON, ALERTS_TOAST_MESSAGE } from "app/pages/activation/components/HomeWithData/Alerts/texts";

import * as SC from "./styles";

type ToastMessageSchema = {
    unreadCount?: number;
    onClick?: () => void;
};

export const ToastMessage = ({ unreadCount = 0, onClick }: ToastMessageSchema) => {
    const { translate } = useTranslate();

    return (
        <SC.Container>
            <SC.IconContainer>
                <SC.InfoDot>{unreadCount}</SC.InfoDot>
                <Info24px size="xs" />
            </SC.IconContainer>

            <SC.TextContainer>
                <Trans
                    i18nKey={ALERTS_TOAST_MESSAGE}
                    components={{ strong: <SC.Bold /> }}
                    count={unreadCount}
                    values={{ count: unreadCount }}
                    t={translate}
                />
            </SC.TextContainer>

            <Button
                type="flatNegative"
                onClick={onClick}
            >
                {translate(ALERTS_TOAST_BUTTON)}
            </Button>
        </SC.Container>
    );
};
